import React, {useEffect} from "react";
import {useStyles} from "./styles/SideMenuStyle";
import {
    Box,
    Button,
    Drawer,
    IconButton,
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
    Typography
} from "@material-ui/core";
import {ReactComponent as DrawerArrowIcon} from '../../common/images/DrawerArrowIcon.svg';
import {ReactComponent as BookIcon} from '../../common/images/BookIcon.svg';
import {ReactComponent as UserProfile} from '../../common/images/UserProfile.svg';
import {ReactComponent as GroupProfile} from '../../common/images/GroupProfile.svg';
import {ReactComponent as LineChart} from '../../common/images/LineChart.svg';
import {ReactComponent as LogoutIcon} from '../../common/images/LogoutIcon.svg';
import clsx from "clsx";
import {inject, observer} from "mobx-react";
import {useHistory} from "react-router-dom";
import {URL_TYPE, USER_HOME} from "../../routes/Routes";
import {COMMON_UTIL} from "../../common/util/common.util";
import {State} from "../../stores/AuthStore";
import {USER_TYPE} from "../../stores/UserStore";
import {injectIntl} from "react-intl";


function SideMenu(props) {
    const {loginUser, loginState} = props.authStore;
    const {sideBarOpen, changSideBarOpen} = props.navigateStore;
    const {authStore, commonStore} = props;
    const {intl} = props;

    const classes = useStyles();
    const history = useHistory();

    useEffect(() => {
        const path = COMMON_UTIL.getUrlPath();

        let sideMenuNum = menuList.findIndex(menu => menu.url === path);
        if (sideMenuNum === -1) {
            if (path.includes('group')) {
                sideMenuNum = menuList.findIndex(menu => menu.url.includes('group'));
            } else if (path.includes('content')) {
                sideMenuNum = menuList.findIndex(menu => menu.url.includes('content'));
            } else if (path.includes('statistics')) {
                sideMenuNum = menuList.findIndex(menu => menu.url.includes('statistics'));
            } else if (path.includes('faq')) {
                sideMenuNum = menuList.findIndex(menu => menu.url.includes('faq'));
            } else if (path.includes('notice')) {
                sideMenuNum = menuList.findIndex(menu => menu.url.includes('notice'));
            } else if (path.includes('push')) {
                sideMenuNum = menuList.findIndex(menu => menu.url.includes('push'));
            } else {
                sideMenuNum = menuList.findIndex(menu => menu.url === USER_HOME[authStore.getUserType()].path);
            }
        }
        commonStore.setSideMenuTab(sideMenuNum);

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const changeLocation = (url, index) => {
        commonStore.setSideMenuTab(index)
        history.push(url);
    }

    const handleLogout = () => {
        authStore.doLogout(() => {
            const homeUrl = USER_HOME['None'].path;

            history.push(homeUrl);
        });
    };

    const userType = props.authStore.getUserType();

    const menuList = [
        {
            title: intl.formatMessage({id: "member_management"}),
            icon: <UserProfile/>,
            url: URL_TYPE.MemberManage
        },
        {
            title: intl.formatMessage({id: "group_management"}),
            icon: <GroupProfile/>,
            url: userType === USER_TYPE.GroupAdmin ? `/group/${loginUser.localeGroupId}` : URL_TYPE.GroupList
        },
        {
            title: intl.formatMessage({id: "statistics"}),
            icon: <LineChart/>,
            url: userType === USER_TYPE.GroupAdmin ? `/statistics/detail/${loginUser.localeGroupId}` : URL_TYPE.Statistics
        },
    ];

    if (loginUser) {
        // if (userType === USER_TYPE.Admin || userType === USER_TYPE.LocaleAdmin) {
        //     menuList.push({
        //         title: intl.formatMessage({id: "push_alarm"}),
        //         icon: <PushAlarm/>,
        //         url: URL_TYPE.Push
        //     });
        //     menuList.push({
        //         title: intl.formatMessage({id: "notification_and_event"}),
        //         icon: <Notification/>,
        //         url: URL_TYPE.Notice
        //     });
        // }
        if (userType === USER_TYPE.Admin) {
            // menuList.unshift({
            //     title: intl.formatMessage({id: "education_contents"}),
            //     icon: <BookIcon/>,
            //     url: URL_TYPE.ContentList
            // });
            menuList.push({
                title: "FAQ",
                icon: <BookIcon/>,
                url: URL_TYPE.FAQ
            });
        }
    }

    return (
        loginState === State.Authenticated ?
            <div>
                <Drawer variant="permanent"
                        open={sideBarOpen}
                        className={clsx(classes.drawer, {
                            [classes.drawerOpen]: sideBarOpen,
                            [classes.drawerClose]: !sideBarOpen,
                        })}
                        classes={{
                            paper: clsx(clsx(classes.drawer, {
                                [classes.drawerOpen]: sideBarOpen,
                                [classes.drawerClose]: !sideBarOpen,
                            }))
                        }}
                >
                    {sideBarOpen ?
                        <Box>
                            <Box display='flex' alignItems='center' justifyContent='space-between'
                                 className={classes.logoBox}>
                                <Typography>English Edu</Typography>
                                <IconButton onClick={changSideBarOpen} className={classes.iconButton} disableRipple>
                                    <DrawerArrowIcon/>
                                </IconButton>
                            </Box>
                            <Box className={classes.menuBox}>
                                <List>
                                    {menuList.map((menu, index) => (
                                        <ListItem key={index}
                                                  className={index === commonStore.sideMenuTab ? clsx(classes.selectListItemStyle, classes.listItemStyle) : classes.listItemStyle}
                                                  button disableRipple onClick={() => changeLocation(menu.url, index)}>
                                            {/*<ListItem key={index} className={classes.listItemStyle} button disableRipple onClick={()=>changeLocation(menu.url, index)}>*/}
                                            <ListItemIcon>
                                                {menu.icon}
                                            </ListItemIcon>
                                            <ListItemText primary={menu.title}/>
                                        </ListItem>
                                    ))}
                                </List>
                            </Box>
                            <Box className={classes.sideLogin}>
                                <Button style={{display: 'flex', alignItems: 'center', justifyContent: 'center'}}
                                        onClick={handleLogout} disableRipple>
                                    <LogoutIcon/>
                                    <Typography>
                                        {intl.formatMessage({id: "logout"})}
                                    </Typography>
                                </Button>
                            </Box>
                        </Box>
                        :
                        <Box>
                            <Box display='flex' alignItems='center' justifyContent='center'
                                 className={classes.closeLogoBox}>
                                <IconButton onClick={changSideBarOpen} className={classes.iconButton} disableRipple>
                                    <DrawerArrowIcon style={{transform: 'scaleX(-1)'}}/>
                                </IconButton>
                            </Box>

                            <Box className={classes.menuBox}>
                                <List>
                                    {menuList.map((menu, index) => (
                                        <ListItem key={index}
                                                  className={index === commonStore.sideMenuTab ? clsx(classes.selectListItemStyle, classes.listItemStyle) : classes.listItemStyle}
                                                  button disableRipple onClick={() => changeLocation(menu.url, index)}>
                                            {/*<ListItem key={index} className={classes.listItemStyle} button disableRipple onClick={()=>changeLocation(menu.url, index)}>*/}
                                            <ListItemIcon>
                                                {menu.icon}
                                            </ListItemIcon>
                                        </ListItem>
                                    ))}
                                </List>
                            </Box>
                            {/*<Box className={classes.menuBox}>*/}
                            {/*    <List>*/}
                            {/*        <ListItem className={classes.listItemStyle} button disableRipple>*/}
                            {/*            <ListItemIcon>*/}
                            {/*                <BookIcon/>*/}
                            {/*            </ListItemIcon>*/}
                            {/*        </ListItem>*/}
                            {/*    </List>*/}
                            {/*</Box>*/}
                            <Box className={clsx(classes.sideLogin, classes.loginClose)}>
                                <Button disableRipple display='flex' alignItems='center' justifyContent='center'>
                                    <LogoutIcon/>
                                </Button>
                            </Box>
                        </Box>
                    }
                </Drawer>
            </div>
            : <></>

    );
}

export default inject('authStore', 'navigateStore', 'commonStore')(injectIntl(observer(SideMenu)))
